var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surround-box',[_c('div',{staticClass:"base-info-container"},[_c('div',{staticClass:"base-info-title"},[_vm._v("企业介绍")]),_c('div',{staticClass:"base-info-content-container"},[_c('div',{staticClass:"base-info-detail",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }